'use client';

import { useCallback, useState } from 'react';

/**
 * Hook that manages a boolean state with toggle functionality.
 * Provides both toggle and direct set capabilities for boolean values.
 *
 * @param {boolean} [initialValue=false] - The initial boolean state value.
 * @returns {[boolean, (newValue?: boolean) => void]} Tuple containing the current state and toggle function.
 */
export const useToggle = (initialValue = false): [boolean, (newValue?: boolean) => void] => {
  const [on, setOn] = useState<boolean>(initialValue);

  const handleToggle = useCallback((value?: boolean) => {
    if (typeof value === 'boolean') {
      return setOn(value);
    }

    return setOn((v) => !v);
  }, []);

  return [on, handleToggle];
};
